import { RouterModule, Routes } from '@angular/router';

import { DashboardComponent } from './dashboard/dashboard.component';
import { DeliveriesListComponent } from './deliveries-list/deliveries-list.component';
import { DeliveryDetailComponent } from './delivery-detail/delivery-detail.component';
import { LoadingSlotVisualComponent } from './loading-slot-visual/loading-slot-visual.component';
import { LoginComponent } from './login/login.component';
import { NewDeliveryComponent } from './new-delivery/new-delivery.component';
import { NewInboundDeliveryComponent } from './new-inbound-delivery/new-inbound-delivery.component';
import { ReportDetailComponent } from './report-detail/report-detail.component';
import { ReportsListComponent } from './reports-list/reports-list.component';
import { SnakeComponent } from './secret/snake.component';
import { AuthguardService } from './services/authguard.service';
import { DeliveryBarrierService } from './services/delivery-barrier.service';
import { SecretService } from './services/secret.service';
import { VIPResolverService } from './services/VIPResolver.service';
import { SetPasswordComponent } from './set-password/set-password.component';
import { SettingsComponent } from './settings/settings.component';
import { StatusListComponent } from './status-list/status-list.component';
import { TransactionDetailComponent } from './transaction-detail/transaction-detail.component';
import { TransactionsListComponent } from './transactions-list/transactions-list.component';

const appRoutes: Routes = [
    {
        path: '',
        redirectTo: '/login',
        pathMatch: 'full'
    },
    {
        path: 'login',
        component: LoginComponent
    },
    {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [AuthguardService]
    },
    {
        path: 'loadingSlotVisual',
        component: LoadingSlotVisualComponent,
        canActivate: [AuthguardService]
    },

    {
        path: 'reportsList',
        component: ReportsListComponent,
        canActivate: [AuthguardService]
    },
    {
        path: 'newDelivery',
        component: NewDeliveryComponent,
        canActivate: [AuthguardService, DeliveryBarrierService],
        // resolve: { VIP: VIPResolverService }
    },
    {
        path: 'newInboundDelivery',
        component: NewInboundDeliveryComponent,
        canActivate: [AuthguardService],
        // resolve: { VIP: VIPResolverService }
    },
    {
        path: 'statusList',
        component: StatusListComponent,
        canActivate: [AuthguardService]
    },
    {
        path: 'settings',
        component: SettingsComponent,
        canActivate: [AuthguardService]
    },
    {
        path: 'deliveriesList',
        component: DeliveriesListComponent,
        canActivate: [AuthguardService]
    },
    {
        path: 'reportDetail/:reportId',
        component: ReportDetailComponent,
        canActivate: [AuthguardService]
    },
    {
        path: 'deliveryDetail/:lieferNr',
        component: DeliveryDetailComponent,
        canActivate: [AuthguardService]
    },
    {
        path: 'pro',
        component: SetPasswordComponent,
        canActivate: [AuthguardService]
    },
    {
        path: 'transactionsList',
        component: TransactionsListComponent,
        canActivate: [AuthguardService]
    },
    {
        path: 'transactionDetail/:transactionId/:balanceId',
        component: TransactionDetailComponent,
        canActivate: [AuthguardService]
    },
    {
        path: 'secret',
        component: SnakeComponent,
        canActivate: [SecretService]
    }

];

export const routing = RouterModule.forRoot(appRoutes, { useHash: true });
